export const general = {
  methods: {
    _back () {
      window.history.back()
    }
  }
}
